import { RouteComponentProps, withRouter } from 'react-router';
import './PresentationMode.css';
import EmbeddedContent, { buildEntityContext } from '../../common/EmbeddedContent/EmbeddedContent';
import { DefaultButton } from 'office-ui-fabric-react';
import { EntityType } from '../../../entities/common';

type Props = {
    entityType: EntityType;
    isForce: boolean;
    url?: string;
    setIsEnabled: (isEnabled: boolean) => void;
}

const PresentationMode = (props: Props & RouteComponentProps<{ id: string }>) => {
    const { entityType, url, isForce, setIsEnabled } = props;

    return <div className="presentation-mode">
        <div className="leave-container">
            <DefaultButton 
                className="dropdown-button filter-btn" 
                iconProps={{ iconName: 'Cancel' }}
                onClick={() => {
                    isForce && props.history.replace({ ...props.location, state: { ...props.location, presentationMode: false }});
                    setIsEnabled(false);
                }}>
                    Leave Presentation Mode
            </DefaultButton>
        </div>
        <EmbeddedContent url={url} context={buildEntityContext(entityType, props.match.params.id)} />
    </div>
}

export default withRouter(PresentationMode);